"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eighteen/section/aboutSection.tsx */

import { SmartImage } from "@/Components";
import Lightbox, { type LightboxSlide } from "../../Components/Lightbox";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type AboutSectionCounterEighteenFadeInUpsItem = {
    key: Key | null | undefined;
    /** Detected variants: "%" | "+" */
    h30Text?: ReactNode;
    /** Detected variants: "Patient Satisfaction Rate" | "Average Review Score" | "Successful Treatments" */
    p0Text: ReactNode;
    /** Detected variants: "counter-item-eighteen wow fadeInUp" */
    className?: string;
    /** Detected variants: "1s" */
    dataWowDuration?: string;
    /** Detected variants: "count" */
    h30ClassName?: string;
    /** Detected variants: "count-digit" */
    span0ClassName?: string;
    /** Detected variants: "isVisible && <CountUp end={92} duration={2} />" | "isVisible && <CountUp end={4.9} duration={2} decimals={1} />" | "isVisible && <CountUp end={1000} duration={2} />" */
    h30span0Expr0: ReactNode;
};

type AboutSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-25.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    className?: string;
    /** Detected variants: "img" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
};
export type HomeEighteenAboutSectionGeneratedProps = {
    lightboxSlides?: LightboxSlide[];
    lightboxOpen?: boolean;
    lightboxIndex?: number;
    onLightboxClose?: () => void;
    onLightboxView?: (index: number) => void;
    onOpenLightbox?: (index: number) => void;
    divH30H3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSectionCounterEighteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "ABOUT US" */
    sectionDiv0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "We Are Dedicated to Helping" */
    sectionDiv0Div0Div0Div0H20H2Text?: ReactNode;
    /** Default: "Strength & Overall Well being." */
    sectionDiv0Div0Div0Div0H20H2Text2?: ReactNode;
    sectionDiv0Div0Div0Div0H20H2Visible?: boolean;
    sectionDiv0Div0Div0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "Individuals Achieve Better Mobility," */
    sectionDiv0Div0Div0Div0H20Span0SpanText?: ReactNode;
    /** Default: "Play video" */
    sectionDiv0Div0Div1Div0Button0ButtonAriaLabel?: string;
    sectionDiv0Div0Div1Div0Button0ButtonVisible?: boolean;
    sectionDiv0Div0Div1Div0Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0Button0ButtonProps?: Partial<ComponentProps<"button">>;
    /** Default: " Play Video  · Play Video · " */
    sectionDiv0Div0Div1Div0Button0Div0DivDataText?: string;
    sectionDiv0Div1ClassName?: string;
    /** Default: "about-img" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/about/about-img-5.jpg" */
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Trusted Patients" */
    sectionDiv0Div1Div0Div0Div1Div1P0PText?: ReactNode;
    /** Default: "5698+" */
    sectionDiv0Div1Div0Div0Div1Div1P0Span0SpanText?: ReactNode;
    /** Default: "shadow" */
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-5.png" */
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "shadow" */
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/shadow-6.png" */
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    aboutSectionCounterEighteenFadeInUps: AboutSectionCounterEighteenFadeInUpsItem[];
    aboutSectionAvatarAvatarRoundeds: AboutSectionAvatarAvatarRoundedsItem[];
    aboutSectionCounterEighteenFadeInUpsItemWrapper?: (item: AboutSectionCounterEighteenFadeInUpsItem, content: ReactNode) => ReactNode;
    aboutSectionCounterEighteenFadeInUpsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionCounterEighteenFadeInUpsH3Visible?: boolean;
    aboutSectionCounterEighteenFadeInUpsH3Renderer?: (item: AboutSectionCounterEighteenFadeInUpsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionCounterEighteenFadeInUpsH3Props?: Partial<ComponentProps<"h3">> | ((item: AboutSectionCounterEighteenFadeInUpsItem) => Partial<ComponentProps<"h3">>);
    aboutSectionAvatarAvatarRoundedsItemWrapper?: (item: AboutSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    aboutSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarAvatarRoundedsImageVisible?: boolean;
    aboutSectionAvatarAvatarRoundedsImageRenderer?: (item: AboutSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    aboutSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: AboutSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeEighteenAboutSectionGenerated: FC<HomeEighteenAboutSectionGeneratedProps> = ({
    lightboxSlides = [],
    lightboxOpen,
    lightboxIndex,
    onLightboxClose,
    onLightboxView,
    onOpenLightbox,
    sectionDiv0Div0Div0Div0Div0DivText = "ABOUT US",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H20H2Text = "We Are Dedicated to Helping",
    sectionDiv0Div0Div0Div0H20H2Text2 = "Strength & Overall Well being.",
    sectionDiv0Div0Div0Div0H20H2Visible,
    sectionDiv0Div0Div0Div0H20H2Renderer,
    sectionDiv0Div0Div0Div0H20H2Props,
    sectionDiv0Div0Div0Div0H20Span0SpanText = "Individuals Achieve Better Mobility,",
    sectionDiv0Div0Div1Div0Button0ButtonAriaLabel = "Play video",
    sectionDiv0Div0Div1Div0Button0ButtonVisible,
    sectionDiv0Div0Div1Div0Button0ButtonRenderer,
    sectionDiv0Div0Div1Div0Button0ButtonProps,
    sectionDiv0Div0Div1Div0Button0Div0DivDataText = " Play Video  · Play Video · ",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt = "about-img",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/about/about-img-5.jpg",
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div0Div0Div1Div1P0PText = "Trusted Patients",
    sectionDiv0Div1Div0Div0Div1Div1P0Span0SpanText = "5698+",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt = "shadow",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/shadow-5.png",
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageAlt = "shadow",
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/shadow-6.png",
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div1Div1Div0ImageWithBasePath1ImageProps,
    divH30H3Props,
    spanImageWithBasePath0ImageProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div1ClassName,
    aboutSectionCounterEighteenFadeInUps,
    aboutSectionAvatarAvatarRoundeds,
    aboutSectionCounterEighteenFadeInUpsItemWrapper,
    aboutSectionCounterEighteenFadeInUpsRenderer,
    aboutSectionCounterEighteenFadeInUpsH3Visible,
    aboutSectionCounterEighteenFadeInUpsH3Renderer,
    aboutSectionCounterEighteenFadeInUpsH3Props,
    aboutSectionAvatarAvatarRoundedsItemWrapper,
    aboutSectionAvatarAvatarRoundedsRenderer,
    aboutSectionAvatarAvatarRoundedsImageVisible,
    aboutSectionAvatarAvatarRoundedsImageRenderer,
    aboutSectionAvatarAvatarRoundedsImageProps,
}) => {
    return (
        <>
            <section className="section about-section-eighteen">
                <div className="container">
                    <div className={sectionDiv0Div0ClassName ?? "row align-items-center row-gap-4 mb-5"}>
                        <div className="col-lg-9">
                            <div className="section-header-eighteen mb-0 text-lg-start wow fadeInDown" data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                                <div className="sub-title">{sectionDiv0Div0Div0Div0Div0DivText}</div>
                                {renderNode(sectionDiv0Div0Div0Div0H20H2Visible, sectionDiv0Div0Div0Div0H20H2Renderer, (
                                    <h2 className="section-title" {...(sectionDiv0Div0Div0Div0H20H2Props ?? {})}>
                                        {sectionDiv0Div0Div0Div0H20H2Text}
                                        <span className="d-block">{sectionDiv0Div0Div0Div0H20Span0SpanText}</span>
                                        {sectionDiv0Div0Div0Div0H20H2Text2}
                                    </h2>
                                ))}
                            </div>
                        </div>
                        <div className="col-lg-3">
                            <div className="video-btn">
                                {renderNode(sectionDiv0Div0Div1Div0Button0ButtonVisible, sectionDiv0Div0Div1Div0Button0ButtonRenderer, (
                                    <button type="button" onClick={() => onOpenLightbox?.(0)} style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }} aria-label={sectionDiv0Div0Div1Div0Button0ButtonAriaLabel} {...(sectionDiv0Div0Div1Div0Button0ButtonProps ?? {})}>
                                        <div className="animate-button2" data-text={sectionDiv0Div0Div1Div0Button0Div0DivDataText}>
                                            <span className="button-text2"></span>
                                            <span className="button-circle">
                                                <i className="isax isax-play"></i>
                                            </span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className={sectionDiv0Div1ClassName ?? "row row-gap-4"}>
                        <div className="col-xxl-9 col-xl-8 col-lg-8">
                            <div className="about-content-eighteen">
                                <div className="about-img">
                                    {renderNode(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                        <SmartImage src={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div1Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                                    ))}
                                </div>
                                <div className="rating-appointment flex-wrap">
                                    <div className="avatar-list-stacked avatar-group-lg">
                                        {renderCollectionNode(
                                            aboutSectionAvatarAvatarRoundeds,
                                            (item: AboutSectionAvatarAvatarRoundedsItem) => (
                                                <span className={item.className ?? "avatar avatar-rounded"} key={item.key}>
                                                    {renderItemNode(aboutSectionAvatarAvatarRoundedsImageVisible, aboutSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                        <SmartImage className={item.imageWithBasePath0ClassName ?? "img-fluid"} src={item.src} alt={item.alt ?? "img"} {...(typeof aboutSectionAvatarAvatarRoundedsImageProps === "function" ? aboutSectionAvatarAvatarRoundedsImageProps(item) : (aboutSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </span>
                                            ),
                                            aboutSectionAvatarAvatarRoundedsItemWrapper,
                                            aboutSectionAvatarAvatarRoundedsRenderer
                                        )}
                                    </div>
                                    <div>
                                        <p className="avatar-ttile">
                                            <span className="d-block">{sectionDiv0Div1Div0Div0Div1Div1P0Span0SpanText}</span>
                                            {sectionDiv0Div1Div0Div0Div1Div1P0PText}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xxl-3 col-xl-4 col-lg-4">
                            <div className="counter-details-eighteen">
                                {renderCollectionNode(
                                    aboutSectionCounterEighteenFadeInUps,
                                    (item: AboutSectionCounterEighteenFadeInUpsItem) => (
                                        <div className={item.className ?? "counter-item-eighteen wow fadeInUp"} data-wow-duration={item.dataWowDuration ?? "1s"} key={item.key}>
                                            {renderItemNode(aboutSectionCounterEighteenFadeInUpsH3Visible, aboutSectionCounterEighteenFadeInUpsH3Renderer, item, (
                                                <h3 className={item.h30ClassName ?? "count"} {...(typeof aboutSectionCounterEighteenFadeInUpsH3Props === "function" ? aboutSectionCounterEighteenFadeInUpsH3Props(item) : (aboutSectionCounterEighteenFadeInUpsH3Props ?? {}))} {...(typeof divH30H3Props === "function" ? divH30H3Props(item) : (divH30H3Props ?? {}))}>
                                                    <span className={item.span0ClassName ?? "count-digit"}></span>
                                                    {item.h30Text}
                                                </h3>
                                            ))}
                                            <p>{item.p0Text}</p>
                                        </div>
                                    ),
                                    aboutSectionCounterEighteenFadeInUpsItemWrapper,
                                    aboutSectionCounterEighteenFadeInUpsRenderer
                                )}
                                {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath0ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath0ImageAlt} className="img-fluid shadow-1" {...(sectionDiv0Div1Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                                ))}
                                {renderNode(sectionDiv0Div1Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div1Div1Div0ImageWithBasePath1ImageRenderer, (
                                    <SmartImage src={sectionDiv0Div1Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div1Div1Div0ImageWithBasePath1ImageAlt} className="img-fluid shadow-2" {...(sectionDiv0Div1Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Lightbox images={lightboxSlides} currentIndex={lightboxIndex ?? 0} isOpen={lightboxOpen} onClose={() => onLightboxClose?.()} onNavigate={(index) => onLightboxView?.(index)} />
        </>
    );
};

export default HomeEighteenAboutSectionGenerated;
